const { VITE_OBS_BUCKET_NAME } = import.meta.env;

// 全局默认配置项
// 首页地址（默认）
export const HOME_URL: string = "";

export const ERROR_403: string = "/error/403";

// 登录页地址（默认）
export const LOGIN_URL: string = "/login";

// pinia仓库前缀
export const PINIA_PREFIX: string = "landcloud-";

// Svg本地图片使用 landcloud- 开头才会生效
export const SVG_PREFIX: string = "landcloud-";

// 默认主题颜色
export const DEFAULT_THEME: string = "#6169FF";

// 路由白名单地址（本地存在的路由 staticRouter.ts 中）
export const ROUTER_WHITE_LIST: string[] = ["/map", "/500", "/404", "/403"];

// OBS桶配置
export const OBS_NAME: string = VITE_OBS_BUCKET_NAME;

// 服务前缀
export const SERVICE_PREFIX = "landCloudWork3";

// 服务前缀
export const SERVICE_PREFIX_A = "land";
